import axiosConfig from "./axiosConfig";

class DepenseService {
  async getAll() {
    try {
      const response = await axiosConfig.get("/caisse");
      return response.data || [];
    } catch (error) {
      console.error("Error fetching depenses:", error);
      return [];
    }
  }

  async create(formData) {
    try {
      const response = await axiosConfig.post("/caisse", formData);
      return response.data;
    } catch (error) {
      console.error(
        "❌ Erreur lors de la création:",
        error.response?.data || error.message
      );
      return Promise.reject(error.response?.data || { message: error.message });
    }
  }

  async update(id, formData) {
    try {
      const response = await axiosConfig.patch(`/caisse/${id}`, formData);
      return response.data;
    } catch (error) {
      console.error(
        "❌ Erreur lors de la mise à jour:",
        error.response?.data || error.message
      );
      return Promise.reject(error.response?.data || { message: error.message });
    }
  }

  async delete(id) {
    try {
      const response = await axiosConfig.delete(`/caisse/${id}`);
      return response.data;
    } catch (error) {
      console.error(
        "❌ Erreur lors de la suppression:",
        error.response?.data || error.message
      );
      return Promise.reject(error.response?.data || { message: error.message });
    }
  }
}

const DepenseServiceInstance = new DepenseService();
export default DepenseServiceInstance;
